// src/components/Footer.jsx
import React from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-indigo-900 text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          {/* Logo / Brand */}
          <div className="text-2xl sm:text-3xl font-bold">
            {t('Qyntix')}
          </div>

          {/* Navigation links */}
          <nav className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 text-center">
            <a href="#hero" className="hover:text-cyan-500 transition-colors" aria-label="Inicio de Qyntix">
              {t('nav_home')}
            </a>
            <a href="#quienes-somos" className="hover:text-cyan-500 transition-colors" aria-label="Quiénes Somos en Qyntix">
              {t('nav_about')}
            </a>
            <a href="#servicios" className="hover:text-cyan-500 transition-colors" aria-label="Servicios de Qyntix">
              {t('nav_services')}
            </a>
            <a href="#contacto" className="hover:text-cyan-500 transition-colors" aria-label="Contacto de Qyntix">
              {t('nav_contact')}
            </a>
          </nav>

          {/* Social icons */}
          <div className="flex space-x-6">
            <a
              href="https://linkedin.com/company/qyntix"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn de Qyntix"
              className="text-white hover:text-cyan-500 transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Back to top & copyright */}
        <div className="mt-8 text-center space-y-4">
          <p className="text-sm sm:text-base">
           {t('footer_copyright')}
          </p>
          <a
            href="#hero"
            className="text-cyan-500 hover:underline text-sm sm:text-base"
            aria-label="Volver al inicio de la página"
          >
            {t('footer_back_to_top')}
          </a>
        </div>
      </div>
    </footer>
  );
}
